// Here rather than in `@/launchers` so the bootstrap tier can read them too: only that
// directory may hold launcher code, and eslint enforces it.
export const LAUNCHER_TYPES = { BUTTON_PROMPTS: 'BUTTON_PROMPTS', CHAT_BAR: 'CHAT_BAR' } as const;

// CHAT_BAR is anchorless and reaches the page through the entry point, so it never needs
// a renderer, an anchor or the launcher chunk.
const RENDERED_LAUNCHER_TYPES = [LAUNCHER_TYPES.BUTTON_PROMPTS] as const;

export type LauncherType = (typeof LAUNCHER_TYPES)[keyof typeof LAUNCHER_TYPES];

export type RenderedLauncherType = (typeof RENDERED_LAUNCHER_TYPES)[number];

const RENDERED_TYPES = new Set<string>(RENDERED_LAUNCHER_TYPES);

export function isRenderedLauncherType(type: string): type is RenderedLauncherType {
  return RENDERED_TYPES.has(type);
}

// Here for the same reason as the types above: the config validator the bootstrap parses
// with needs the values, and only `@/launchers` may hold launcher code.
export const DISPLAY_RULE_MODES = ['SHOW_ON_MATCH', 'HIDE_ON_MATCH'] as const;

export type DisplayRuleMode = (typeof DISPLAY_RULE_MODES)[number];
